// Animations //
const loading1 = require("./animations/loading/loader1.json");

let options = {
  loading1
};

export { options };
